export default __webpack_public_path__ + "static/dt-ad9be6ea7cd3a23d6e7615d996c06009.png";